export const HOVER_INTENT_DELAY_MS = 120;
export const FAST_PREFETCH_DELAY_MS = 500;
export const SLOW_NETWORK_FALLBACK_MS = 3000;
export const CLOSE_LINGER_MS = 110;
export const PLACEHOLDER_USERNAME = 'placeholder';
